export default __webpack_public_path__ + "static/media/02__o_5.838affbb.jpg";